const WhiteRightArrow = () => {
  return (
    <svg
      width='11'
      height='10'
      viewBox='0 0 11 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <rect
        width='9.7'
        height='10'
        transform='translate(0.890015)'
        fill='url(#pattern0_1237_5249)'
      />
      <defs>
        <pattern
          id='pattern0_1237_5249'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_1237_5249'
            transform='matrix(0.0146907 0 0 0.0142857 0.206186 0)'
          />
        </pattern>
        <image
          id='image0_1237_5249'
          width='40'
          height='70'
          xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABGCAYAAAHJB+bRAAAABGdBTUEAALGPC/xhBQAABOxJREFUaAW9mtmOVDcQhpkBBoblFfIM3M8D8ARcQERYlAWxiEUsElJIhi1kE2Ed9k1CA0JAIECSYec1uEQCKVcICUjCLPzVHJ8ul+06Zfd0Wzqccvmvz/9xNwe7xYwZqTaFxsf6q06/HGjlkexzA328DEmqnHDlbmzCBa07lVKrk5+6fuK5pyApEi/rEhcEpVkD0nzLkjRPxFGHJRfUbsrEnzLxuE5QgJJXrUL84Q2ITu2IxG6sD83F7u4loKX+ZD3ICjyhE8QKokJWUNuJLZBbFye6FnimB2LtD0eu72yQwvv1gAwq4WOZ9/oQDeG64yUjnfqLTGOBaVbgPTVZYGNe2FpHKYiR6wVvEtdCmkcTe0JNHAhT4qgwIv7gLQ8JWNvB4tksbod4qM30YK61R1iEwfVOQHc21A6R/8YiWm0RfWERLW0UwV3+1yz2jWk/JiJMS99wr3mC3A5Idzwa6+SySF9/d4iTAjQ+JiusgS7XKTgAEhhQytcvUzeZu2uOo0BXWAJWgSVgE5CB6e+1/8+3G8SdliIL6GqxFEmw9iZx9d4dsK1IpFyOeGKtA9BGXKl2Rav1xkBYm6Igf90Tax2Iv1JAt7RabwyQlQrorifWOoB8roD+1mq9MUA+U0APPbGlA9jTCPCppTapAZDeibR3G0qKrAOATODi7ZC1NqrjJBYfjIotSQaRYRkUlH2SxPq/WkwFGgAOM4gMfw4KLAlQjkoS6/9kYQQaAI4xiAwPBAWWBCjHJYn1f7AwAg0AIwwiw/1BgSUByklJYv29FkagAeAUg8hwT1BgSYByWpJYf9jCCDQAnGUQGX4fFFgSoJyTJNbfZWEEGgDOM4gMvw0KLAlQLkgS6y+yMAINAJcYhIcvSrciqc3pWDaQ7ASWqwTtlbL2NhoMzFnENTtsgsFcawNlctgAm+1gJocG2DiBXFMdApbcuAMwAGcejKDJNaxgqXGCfXCu+D3qsAE2JwUjcAAEjD6tlLO5gP3PHcnYK6xgwSRVEcH+kwDZr4sbYIMWGMFbQMDo06rhYtZ5gP0rcsku/ZT5BqMzEwqCvU+MRdPekV4o5gP2TuQau6nHXFACo9kIeFtMuxCwtyKX18U67qRPGZdslNuXR5tmNQwkf8MQbn+b5qltOJh4KYw0dct23jY7oQpu6Gel2MfbZLRsNx9asGXgRjsFaGZ/sc0wTSo4OaK5UcbKTh2lvmFEOwIpPqd+LJ0zuw4u6M2rHas0o2VHrmyXKKiMaqcqzWjZiasDoyc0N8pY71741YpqR0rF51TZybCDFdVOlJrR3SVzFtVUK3pGc6OMDRdNWlJUGdWO04rPqe9K5iyqgQvaaWpHdM1o2fG9xGllVDuha0bpF/fetMroRc1NYuxGbxxWs8AEbYxz2j89MQhH23JcMe3irhrERFvYZDnhZYhTR7nOPQO+KccN045229gGNllOeLXbxtbluGHaa4hbP2Z1/rlFCICvwTXJJrSGNyDsqrGvC439jrr4f6SILEB2CvAvC43dRt1A9oTWAsBXFRqjHwW6amwFJig5M99D3RzrAmTrAF9eaOyvbhtbhgnGceW2MRTMzV4JawHgS3CVGHuAukHrPEU6TFCyDXqEunlFE+YWYaLXuKztCYS9MeYeBBPSK6SpPYNgvqvp+R2Tz8S1HRdfTYop171tj+FJPwJTOHpYwOv8MQAAAABJRU5ErkJggg=='
        />
      </defs>
    </svg>
  )
}

export default WhiteRightArrow
